module.exports = __webpack_public_path__ + "static/img/award4.225dda6.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/index/award4.png
// module id = 4HK3
// module chunks = 7